module.exports = __webpack_public_path__ + "img/42.58aebb49.jpg";